<template>
  <div class="card mb-0 shadow">
    <div class="card-body">
      <div class="tab-content">
        <div class="animate__animated animate__fadeIn">
          <div class="row">
            <div class="col-7">
              <h4 class="font-weight-bold">Acompanhamento Mensal</h4>
            </div>
          <div class="col-md-5 text-right flex justify-content-between">
            <button
              class="btn btn-sm btn-primary"
              @click="$bvModal.show('add-acomp-medida-mensal')"
            >
              <i class="fas fa-plus-square" />
              {{ $t("Cadastrar") }}
            </button>   
             <button v-if="medida.acompMensal.length >= 1"
              class="btn btn-sm btn-primary"
              @click="print()"
            >
              <i class="mdi  mdi-printer" />
              {{ $t("Imprimir") }}
            </button>
          </div>
          </div>
          <div class="col-md-12"> 
            <print-content>
              <HeaderMedida class="px-0" :medida="medida"/>
            <div v-if="medida.acompMensal.length == 0">
              <h4 class="text-secondary">
                <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                Ainda não foi registrado nenhum acompanhamento mensal.
              </h4>
            </div>      
            <table v-else class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Compareceu</th>
                  <th>Entrada</th>
                  <th>Saida</th>
                  <th>Carga horária </th>
                  <th>Assinatura (adolescente)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="mensal in medida.acompMensal"
                  :key="mensal.id"
                >
                  <td>{{  formatData(mensal.data)}}</td>
                  <td>{{ mensal.compareceu ==1 ? 'Sim' : 'Não'}}</td>
                  <td>{{ mensal.entrada  }}</td>
                  <td>{{ mensal.saida}}</td>
                  <td>{{ mensal.compareceu == 1 ? mensal.carga_horaria+' Hora(s)' :  '--'}} </td>
                  <td>
                    <!-- <b-button
                      :title="$t('Excluir')"
                      :class="'px-2 mb-0 btn-excluir-' + mensal.id"
                      size="xs"
                      type="button"
                      v-b-tooltip.hover
                      variant="danger"
                      data-style="zoom-in"
                      @click.prevent="deletemensal(mensal.id, index)"
                    >
                      <i class="mdi mdi-delete-forever" />
                    </b-button> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <print-footer 
            v-if="medida.responsavel.tecnico.assinatura_digital"
             :tecnico="medida.responsavel.tecnico" class="mt-0"
              :assinatura="medida.responsavel.tecnico.assinatura_digital"/>
             
            <p  class="text-muted float-right">
              {{ app_cidade }}, {{ app_data_atual }}
            </p>
                   
                 
          </print-content>
          </div>
          <ModalAddAcompMensal :item="medida" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ModalAddAcompMensal from "../ModalAddAcompMensal";
  import HeaderMedida from "../../HeaderMedida";
  const moment = require('moment')
  export default {
    components: { ModalAddAcompMensal,HeaderMedida },
    props: ["medida"],
    data() {
      return {
        app_cidade: this.$store.state.settings.app_cidade,
        app_data_atual: this.$store.state.settings.app_data_atual,
      };
    },
    mounted() {
     
    },
    methods: {
     formatData(value){
      return  moment(value).format("DD/MM/YYYY");
     }
    },
  };
</script>
